import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { kasirNav } from '@/lib/navConfig';
import OutstandingPayments from '@/components/outstanding/OutstandingPayments';

export default function KasirOutstanding() {
  return (
    <AppShell nav={kasirNav} title="Status Telat Pembayaran">
      <OutstandingPayments />
    </AppShell>
  );
}
